import { render, staticRenderFns } from "./StakeDetail.vue?vue&type=template&id=3aa338f2&scoped=true&"
import script from "./StakeDetail.vue?vue&type=script&lang=js&"
export * from "./StakeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa338f2",
  null
  
)

export default component.exports